import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import { LOADING_STATUS } from 'shared/constants';

import { MapState } from '../../types';

import { getPlannerRoutesStations } from '../operations/getPlannerRoutesStations';

export const setRouteStations = (builder: ActionReducerMapBuilder<MapState>) => builder
  .addCase(getPlannerRoutesStations.pending, (state) => {
    state.routes.routeStationsLoadingStatus = LOADING_STATUS.load;
  })
  .addCase(getPlannerRoutesStations.fulfilled, (state, { payload }) => {
    state.routes.routeStationsLoadingStatus = LOADING_STATUS.done;
    state.routes.routeStations = payload;
  })
  .addCase(getPlannerRoutesStations.rejected, (state) => {
    state.routes.routeStationsLoadingStatus = LOADING_STATUS.error;
  });
